/**
 * Local constants for the RCC Buffers page.
 *
 * Mirrors the enums published by RnRRCCFacadeServiceModel
 * (operations/flowMonitoring/buffersOperations.smithy).
 */

/** Window of the buffer trend chart on the drill-down. */
export enum TrendWindow {
    SHIFT = 'SHIFT',
    TWENTY_FOUR_HOUR = 'TWENTY_FOUR_HOUR',
    THREE_DAY = 'THREE_DAY',
    WEEK = 'WEEK',
}

/** Physical container level in a buffer: a pallet holds totes, a tote holds units. */
export enum ContainerType {
    PALLET = 'PALLET',
    TOTE = 'TOTE',
    UNIT = 'UNIT',
}

/** Where a buffered container stands. */
export enum ContainerStatus {
    DROPZONE = 'DROPZONE',
    PROCESSING = 'PROCESSING',
    POTENTIAL_LOST = 'POTENTIAL_LOST',
}
